<template>
  <div>
    <v-row justify="center">
      <v-col
        :xl="6"
        :lg="8"
        :xs="10"
      >
        <v-row>
          <v-col>
            <h1>Booking Complete</h1>
            <p v-if="booking.id">Booking Form ID: <strong>{{ booking.id }}</strong></p>

            <p>Thank you for booking with havebike! We will now be in touch via. email to confirm everything.</p>

            <v-card
              v-if="booking.id"
              class="mb-3"
              outlined
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline">Collection: {{ collectionDate }}</v-list-item-title>
                  <v-list-item-subtitle>{{ booking.collection_address }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>

            <v-card
              v-if="booking.id"
              class="mb-3"
              outlined
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline">Return: {{ returnDate }}</v-list-item-title>
                  <v-list-item-subtitle>{{ booking.return_address }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>

          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="showError"
      color="error"
      bottom
    >
      {{ error }}
      <v-btn
        dark
        text
        @click="showError = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'completePage',

  props: {
    bookingId: {
      type: String,
      required: true
    },
    apiShowSignature: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      booking: {
        bikes: []
      },
      showError: false,
      error: null
    }
  },

  mounted () {
    this.getBooking()
  },

  computed: {
    collectionDate () {
      return moment(this.booking.collection_date).format('ddd Do MMM')
    },

    returnDate () {
      return moment(this.booking.return_date).format('ddd Do MMM')
    }
  },

  methods: {
    getBooking () {
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL
      })
      axiosInstance.defaults.headers.common['Client-Id'] = process.env.VUE_APP_CLIENT_ID
      axiosInstance.get(`/api/bookings/${this.bookingId}/signed?signature=${this.apiShowSignature}`)
        .then(({ data: { data: booking } }) => {
          this.booking = booking
          this.trackPurchase()
        })
        .catch(error => {
          this.showError = true
          this.error = `There was an issue when connecting with the server. ${error.response.data.message}`
        })
    },

    trackPurchase () {
      var products = []
      this.booking.bikes.forEach(bike => {
        products.push({
          'name': bike.service.name,
          'id': bike.service_sku,
          'price': bike.total,
          'brand': 'havebike',
          'category': 'Service',
          'quantity': 1
        })
      })

      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: { step: 6, option: `${this.booking.bikes.length} bikes` },
            products: products
          }
        }
      })

      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          purchase: {
            actionField: {
              'id': this.booking.id,
              'affiliation': 'BOOKING_FORM',
              'revenue': this.booking.total,
              'tax': this.booking.tax,
              'shipping': 0,
              'coupon': this.booking.discount_code_used
            },
            products: products
          }
        }
      })
    }
  }
}
</script>
